module.exports = __webpack_public_path__ + "img/thumbnail-header-3.fd57e24.jpeg";